import React from 'react';
import furniture from '../images/Furniture.jpeg';
import packaging from '../images/packaging.jpeg';
import construction from '../images/Construction 1.png';
import { Link } from 'react-router-dom';

export default function Home() {

    return (
        <>
            <section id="home_section" className="home_sec">
                <div className="home_headings_box">
                    <div className="home_head2 h1" >
                        From Waste To Wonder<span className="header_comma">,</span>
                    </div>

                    <div className="home_head2 h1">Sustainable Bioplastics<span className="header_comma">:</span> Chrissron<span className="header_comma">!!</span>
                    </div>

                    <div className="home_head3 h3">
                        By converting agricultural wastes into value-added products, which would boost the circular economy by providing a sustainable solution through a biorefinery approach.
                    </div>

                    <Link to="/bioplastics" className="see_products">See about bioplastics</Link>

                </div>
                {/* <div className="home_img_div">
                    <img src={homeImg} alt="" className="home_img" />
                </div> */}
            </section >

            <section id="home_about_sec" className="home_about_sec">
                <div id="fake_home_about"></div>
                <div className="home_about_div h2"  >
                    At Chrissron, we craft special bioplastics using a unique process. These eco-friendly materials are like magic in industries such as construction, packaging, electrical, and furniture. Our innovative technology conjures up a green polymer that's a friendly alternative to regular synthetics.
                </div>
                <div>
                    <Link id="home_about_" className="home_about_link" to="/about">Read about us</Link>
                </div>
            </section>

            <section className="home_products_sec">
                <div className="home_products_div h1"  >
                    Applications of Bioplastics
                </div>
                <div className="home_products_item_div">
                    <div className="home_products_item">
                        <img src={furniture} alt="" className="home_products_img" />
                        <div className="h3">Furniture Industry</div>
                        <div className="h4">Bioplastics are transforming the furniture industry by offering a multitude of sustainable applications. From light-weight chairs to tables, bioplastics are utilized in the production of various furniture components. Bio-based polymers can be molded into durable and aesthetically pleasing designs for both indoor and outdoor furniture.</div>
                    </div>
                    <div className="home_products_item">
                        <img src={packaging} alt="" className="home_products_img" />
                        <div className="h3">Packaging Industry</div>
                        <div className="h4">Bioplastics are revolutionizing the packaging industry, offering sustainable alternatives to traditional petroleum-based plastics. Bioplastics are increasingly used in food packaging applications, including trays, clamshells, and wraps. It can also be molded into bottles for beverages, reducing reliance on traditional plastic bottles made from fossil fuels.</div>
                    </div>
                    <div className="home_products_item">
                        <img src={construction} alt="" className="home_products_img" />
                        <div className="h3">Construction Industry</div>
                        <div className="h4">Bioplastics are making significant inroads into the construction industry, with applications ranging from structural elements to innovative products like bio-tiles and pipes. Bio-tiles, for instance, offer an eco-friendly solution for flooring and wall coverings, combining aesthetics with environmental responsibility.</div>
                    </div>
                </div>
                <div className='home_products_link_div'>
                    <Link className="home_products_link" to="/bioplastics">Explore all applications</Link>
                </div>
            </section>

            <section className="home_contact_sec">
                <div className="home_contact_div h2"  >
                    Let’s create a more sustainable future together.
                </div>
                <div className="home_contact_div h4">
                    Interested in learning more about how you can be part of the transition to a circular economy?
                </div>
                <div className='home_products_link_div'>
                    <Link className="home_contact_link" to="mailto:agrimass1985@gmail.com">Contact us</Link>
                </div>
            </section>
        </>
    )



}
